module.exports = __webpack_public_path__ + "static/img/profile.a477e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/rorando/profile.png
// module id = IBMS
// module chunks = 0